import { render } from "./TermsOfUseModal.vue?vue&type=template&id=298e0d8a&ts=true"
import script from "./TermsOfUseModal.vue?vue&type=script&lang=ts"
export * from "./TermsOfUseModal.vue?vue&type=script&lang=ts"

import "./TermsOfUseModal.vue?vue&type=style&index=0&id=298e0d8a&lang=scss"

import exportComponent from "/builds/atx/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__